import React from 'react';

export const AdminVendedoresTable = ({
  vendedores,
  copiedLink,
  onCopyLink,
  onViewLeads,
  onToggleAtivo,
  onOpenEdit,
  onDelete,
}) => {
  return (
    <div className="bg-white rounded-xl shadow overflow-hidden" data-testid="admin-vendedores-table-card">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900" data-testid="admin-vendedores-table-title">Vendedores Cadastrados</h2>
      </div>

      {vendedores.length === 0 ? (
        <div className="p-8 text-center text-gray-500" data-testid="admin-vendedores-empty-state">
          Nenhum vendedor cadastrado. Clique em "Novo Vendedor" para adicionar.
        </div>
      ) : (
        <div className="overflow-x-auto" data-testid="admin-vendedores-table-wrapper">
          <table className="w-full" data-testid="admin-vendedores-table">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Vendedor</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contato</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Link</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Leads</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-testid="admin-vendedores-table-body">
              {vendedores.map((vendedor) => (
                <tr key={vendedor.id} className={!vendedor.ativo ? 'bg-gray-50 opacity-60' : ''} data-testid={`admin-vendedores-row-${vendedor.id}`}>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden" data-testid={`admin-vendedores-avatar-${vendedor.id}`}>
                        {vendedor.foto_url ? (
                          <img src={vendedor.foto_url} alt="" className="w-full h-full object-cover" data-testid={`admin-vendedores-photo-${vendedor.id}`} />
                        ) : (
                          <span className="text-lg">👤</span>
                        )}
                      </div>
                      <div>
                        <div className="font-medium text-gray-900" data-testid={`admin-vendedores-name-${vendedor.id}`}>{vendedor.nome}</div>
                        <div className="text-sm text-gray-500" data-testid={`admin-vendedores-specialty-${vendedor.id}`}>{vendedor.especialidade}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm" data-testid={`admin-vendedores-contact-${vendedor.id}`}>
                      {vendedor.telefone && <div data-testid={`admin-vendedores-phone-${vendedor.id}`}>📞 {vendedor.telefone}</div>}
                      {vendedor.email && <div className="text-gray-500" data-testid={`admin-vendedores-email-${vendedor.id}`}>✉️ {vendedor.email}</div>}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2" data-testid={`admin-vendedores-link-cell-${vendedor.id}`}>
                      <code className="text-xs bg-gray-100 px-2 py-1 rounded" data-testid={`admin-vendedores-short-link-${vendedor.id}`}>/v/{vendedor.codigo}</code>
                      <button
                        onClick={() => onCopyLink(vendedor)}
                        className={`text-xs px-2 py-1 rounded transition ${
                          copiedLink === vendedor.id
                            ? 'bg-green-100 text-green-700'
                            : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                        }`}
                        data-testid={`admin-vendedores-copy-link-button-${vendedor.id}`}
                      >
                        {copiedLink === vendedor.id ? '✓ Copiado!' : 'Copiar'}
                      </button>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => onViewLeads(vendedor)}
                      className="text-blue-600 hover:text-blue-700 font-medium"
                      data-testid={`admin-vendedores-view-leads-button-${vendedor.id}`}
                    >
                      {vendedor.leads_count || 0} leads
                    </button>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => onToggleAtivo(vendedor)}
                      className={`px-3 py-1 rounded-full text-sm font-medium transition ${
                        vendedor.ativo
                          ? 'bg-green-100 text-green-700 hover:bg-green-200'
                          : 'bg-red-100 text-red-700 hover:bg-red-200'
                      }`}
                      data-testid={`admin-vendedores-toggle-status-button-${vendedor.id}`}
                    >
                      {vendedor.ativo ? '✓ Ativo' : '✗ Inativo'}
                    </button>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2" data-testid={`admin-vendedores-actions-${vendedor.id}`}>
                      <button
                        onClick={() => onOpenEdit(vendedor)}
                        className="text-blue-600 hover:text-blue-700"
                        data-testid={`admin-vendedores-edit-button-${vendedor.id}`}
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => onDelete(vendedor)}
                        className="text-red-600 hover:text-red-700"
                        data-testid={`admin-vendedores-delete-button-${vendedor.id}`}
                      >
                        Excluir
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
